import React from 'react';

const SchedulePage: React.FC = () => {
  return (
    <div className="section">
      <div className="container">
        <h1 className="section-title">مواعيد الكورسات المتاحة</h1>
        
        <div className="card">
          <div className="card-content">
            <p>
              نقدم مجموعة متنوعة من الكورسات لتعليم اللغة الإنجليزية للأطفال من مختلف الأعمار والمستويات.
              يرجى الاطلاع على الجدول أدناه لمعرفة المواعيد المتاحة حالياً.
            </p>
          </div>
        </div>
        
        <table className="schedule-table">
          <thead>
            <tr>
              <th>اسم الكورس</th>
              <th>الفئة العمرية</th>
              <th>الأيام</th>
              <th>الوقت</th>
              <th>المدة</th>
              <th>الحالة</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>تأسيس المبتدئين</td>
              <td>4-6 سنوات</td>
              <td>السبت والاثنين</td>
              <td>4:00 - 5:00 مساءً</td>
              <td>8 أسابيع</td>
              <td>متاح</td>
            </tr>
            <tr>
              <td>الحروف والكلمات</td>
              <td>5-7 سنوات</td>
              <td>الأحد والأربعاء</td>
              <td>5:00 - 6:00 مساءً</td>
              <td>10 أسابيع</td>
              <td>متاح</td>
            </tr>
            <tr>
              <td>المحادثة للأطفال</td>
              <td>7-9 سنوات</td>
              <td>الثلاثاء والخميس</td>
              <td>4:30 - 5:30 مساءً</td>
              <td>12 أسبوع</td>
              <td>اكتمل التسجيل</td>
            </tr>
            <tr>
              <td>القراءة والكتابة</td>
              <td>8-10 سنوات</td>
              <td>السبت</td>
              <td>10:00 - 12:00 صباحاً</td>
              <td>8 أسابيع</td>
              <td>متاح</td>
            </tr>
            <tr>
              <td>الإنجليزية من خلال القصص</td>
              <td>6-8 سنوات</td>
              <td>الجمعة</td>
              <td>5:00 - 6:30 مساءً</td>
              <td>6 أسابيع</td>
              <td>متاح</td>
            </tr>
            <tr>
              <td>مخيم الصيف التعليمي</td>
              <td>5-10 سنوات</td>
              <td>الأحد إلى الخميس</td>
              <td>9:00 - 12:00 صباحاً</td>
              <td>3 أسابيع</td>
              <td>قريباً</td>
            </tr>
          </tbody>
        </table>
        
        <div className="card" style={{ marginTop: '30px' }}>
          <div className="card-content">
            <h3>معلومات التسجيل</h3>
            <p>
              للتسجيل في أي من الكورسات المتاحة، يرجى التواصل معنا عبر:
            </p>
            <ul>
              <li>الهاتف: 01103303645</li>
              <li>البريد الإلكتروني: nagamwagdy4@gmail.com</li>
            </ul>
            <p>
              يتم تحديد المستوى المناسب للطفل من خلال جلسة تقييم مجانية قبل بدء الكورس.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SchedulePage;
